export enum SourceApps {
    cms = 'cms',
    catering = 'catering',
    order = 'order',
}
